/**
 * Map Patient Notification table column keys to backend `sort_by` fields.
 *
 * CustomTable uses camelCase column keys; the clinical-trials API expects the
 * snake_case names registered in `notification_query._SORT_GETTERS`.
 */

/** Frontend column key -> backend sort_by field. Unmapped columns omit sort_by. */
const SORT_KEY_TO_BACKEND: Record<string, string> = {
  name: "patient_name",
  nextAppointment: "next_appointment",
  stage: "stage",
  insurance: "insurance",
  diagnosis: "diagnosis",
};

/**
 * Translate a table column sort key into the API `sort_by` value.

 * @param sortKey - Controlled table column key, or null when unsorted
 * @returns Backend sort field, or undefined to use the tab default sort
 */
export function toBackendNotificationSortBy(
  sortKey: string | null | undefined,
): string | undefined {
  if (!sortKey) return undefined;
  return SORT_KEY_TO_BACKEND[sortKey];
}
